import { render } from "./UserTaskPanel.vue?vue&type=template&id=638d9756"
import script from "./UserTaskPanel.vue?vue&type=script&lang=js"
export * from "./UserTaskPanel.vue?vue&type=script&lang=js"

import "./UserTaskPanel.vue?vue&type=style&index=0&id=638d9756&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__